// Shared constants for the Theming tab. Pure values only, no React.

// Responses API: how many rows to fetch per page (useSWRInfinite key).
export const RESPONSES_PAGE_SIZE = 50;

// Comprehend (Gobby Assist) processing poll interval and overall
// timeout. The timeout caps polling so a stuck backend doesn't spin
// forever; the interval is short enough to feel responsive but not so
// short that we hammer the API.
export const COMPREHEND_POLL_INTERVAL_MS = 5_000;
export const COMPREHEND_TIMEOUT_MS = 60_000;

// Chip display: how many characters of a text/theme/keyword value to
// show before the ellipsis. Full text remains available via tooltip.
export const CHIP_TRUNCATE_LENGTH = 10;

// Initial ThemingTabFilters state shape. Exported so theming-tab.jsx
// (initial useState) and any future tests can reference the same
// canonical empty-state object instead of duplicating the literal.
export const INITIAL_FILTERS = Object.freeze({
    questions: [],
    themes: [],
    texts: [],
    keywords: [],
    unthemed: false,
});
